var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FadeItem',[(_vm.positive)?_c('span',[_vm._v(" Resposta correta "),_c('img',{attrs:{"src":require("../assets/correct.svg")}})]):_c('span',[_vm._v(" Resposta incorreta "),_c('img',{attrs:{"src":require("../assets/incorrect.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }